import { useEffect, useState } from "react";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, useWatch } from "react-hook-form";
import { Add } from "../../services/offer.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import { useNavigate } from "react-router-dom";

const FormSchema = z
  .object({


    name: z.string().min(3),
  
    description: z.string().min(5),
    offered_price: z.coerce.number().min(1, "Price must be greater than 0"),
    limit_per_person: z.coerce.number().min(1, "Must be at least 1"),
    expiry_date: z.coerce.date().min(new Date("2025-08-01"), { error: "Too old!" }),
  })
  .superRefine((data, ctx) => {
   
  });

export default function BusinessCoupons() {
  const [discountType, setDiscountType] = useState("");
  const navigate = useNavigate();

  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {


    name: "",
  
    description: "",
    offered_price: "",
    limit_per_person: "",
    expiry_date: new Date(),
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = form;

 

 

  async function onSubmit(data) {
    try {
      console.log('--------data', data);
      const response = await Add(data);
      if (response.success) {
        Swal.fire({
          icon: "success",
          text: response.message,
          ...SWAL_SETTINGS,
        });
        setTimeout(() => {
          navigate("/business/coupons/1");
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          text: response.message,
          ...SWAL_SETTINGS,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error?.response?.data?.message || "Something went wrong",
        ...SWAL_SETTINGS,
      });
    }
  }

  return (
    <div className="main-content">
      <div className="support-part">
        <div className="card-box">
          <div className="mx-auto">
            <h3 className="h3-headline text-center mb-4">Create a new Offer</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row g-3 text-start">
                {/* Coupon Title */}
                <div className="col-md-6">
                  <label className="form-label subtitle-1" htmlFor="title">
                    Name<span className="requirestar">*</span>
                  </label>
                  <input {...register("name")} type="text" className="form-control" id="title" placeholder="Enter Offer title" />
                  {errors.name && <p className="text-danger mt-1">{errors.name.message}</p>}
                </div>

                {/* Coupon Code */}
             

                <div className="col-md-6">
                  <label className="form-label subtitle-1" htmlFor="offered_price">
                    Offered Price<span className="requirestar">*</span>
                  </label>
                  <input {...register("offered_price")} type="number" className="form-control" id="offered_price" placeholder="Enter Offer offer price" />
                  {errors.offered_price && <p className="text-danger mt-1">{errors.offered_price.message}</p>}
                </div>

                {/* Limit Per Person */}
                <div className="col-md-6">
                  <label className="form-label subtitle-1" htmlFor="limit_per_person">
                    Limit Per Person<span className="requirestar">*</span>
                  </label>
                  <input {...register("limit_per_person")} type="number" className="form-control" id="limit_per_person" placeholder="Enter limit per person" />
                  {errors.limit_per_person && <p className="text-danger mt-1">{errors.limit_per_person.message}</p>}
                </div>

                <div className="col-md-6">
                  <label className="form-label subtitle-1" htmlFor="expiryDate">
                    Expiry Date<span className="requirestar">*</span>
                  </label>
                  <input {...register("expiry_date")} type="date" className="form-control" id="expiryDate" placeholder="Enter expiry date" />
                  {errors.expiry_date && <p className="text-danger mt-1">{errors.expiry_date.message}</p>}
                </div>

                <div className="col-md-12">
                  <label className="form-label subtitle-1" htmlFor="description">
                    Description<span className="requirestar">*</span>
                  </label>
                  <textarea {...register("description")} className="form-control form-control-business" id="description" placeholder="Enter description" rows={5} />
                  {errors.description && <p className="text-danger mt-1">{errors.description.message}</p>}
                </div>
              </div>

              <div className="text-center mt-5">
                <button type="submit" className="btn btn-light-purple px-5">
                  Create Offer
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
